import { CardElement, useElements, useStripe } from "@stripe/react-stripe-js";
import React, { useEffect, useState } from "react";

const CheckoutForm = ({ orders }) => {
  const [cardError, setCardError] = useState("");
  const [success, setSuccess] = useState("");
  const [transactionId, setTransactionId] = useState("");
  const [clientSecret, setClientSecret] = useState("");
  const [processing, setProcessing] = useState(false);
  const stripe = useStripe();
  const elements = useElements();
  const { price, customerEmail, customerName, _id, productImg } = orders;

  useEffect(() => {
    // Create PaymentIntent as soon as the page loads
    fetch("https://boi-poka-server.vercel.app/create-payment-intent", {
      method: "POST",
      headers: {
        "Content-Type": "application/json",
        authorization: `bearer ${localStorage.getItem("token")}`,
      },
      body: JSON.stringify({ price }),
    })
      .then((res) => res.json())
      .then((data) => setClientSecret(data.clientSecret));
  }, [price]);

  const handleSubmit = async (event) => {
    event.preventDefault();
    if (!stripe || !elements) {
      return;
    }
    const card = elements.getElement(CardElement);

    if (card === null) {
      return;
    }

    const { error, paymentMethod } = await stripe.createPaymentMethod({
      type: "card",
      card,
    });
    if (error) {
      setCardError(error.message);
    } else {
      setCardError("");
    }

    setSuccess("");
    setProcessing(true);
    const { paymentIntent, error: confirmError } =
      await stripe.confirmCardPayment(clientSecret, {
        payment_method: {
          card: card,
          billing_details: {
            name: customerName,
            email: customerEmail,
          },
        },
      });

    if (confirmError) {
      setCardError(confirmError.message);
      return;
    }

    if (paymentIntent?.status === "succeeded") {
      const paymentInfo = {
        price,
        transactionId: paymentIntent?.id,
        orderId: _id,
        customerEmail: customerEmail,
      };
      fetch("https://boi-poka-server.vercel.app/payments", {
        method: "POST",
        headers: {
          "content-type": "application/json",
          authorization: `bearer ${localStorage.getItem("token")}`,
        },
        body: JSON.stringify(paymentInfo),
      })
        .then((res) => res.json())
        .then((data) => {
          console.log(data);
          if (data?.insertedId) {
            fetch(
              `https://boi-poka-server.vercel.app/books?image=${productImg}`,
              {
                method: "PUT",
                headers: {
                  "content-type": "application/json",
                  authorization: `bearer ${localStorage.getItem("token")}`,
                },
              }
            );

            setSuccess("Congratulation ! Your Payment Completed");
            setTransactionId(paymentIntent?.id);
          }
        });
    }
    setProcessing(false);
  };
  return (
    <form onSubmit={handleSubmit}>
      <CardElement
        options={{
          style: {
            base: {
              fontSize: "16px",
              color: "#424770",
              "::placeholder": {
                color: "#aab7c4",
              },
            },
            invalid: {
              color: "#9e2146",
            },
          },
        }}
      />
      <button
        type="submit"
        className="btn btn-sm mt-10"
        disabled={!stripe || !clientSecret || processing || success}
      >
        Pay
      </button>

      <p className="text-red-600 font-bold text-center py-5">{cardError}</p>

      {success && (
        <div className="font-bold text-center py-5">
          <p className="text-green-600 ">{success}</p>
          <p>
            Your transaction id : <strong>{transactionId}</strong>
          </p>
        </div>
      )}
    </form>
  );
};

export default CheckoutForm;
